var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"gutter"}),_vm._m(0),_c('div',{staticClass:"container page-negative negative-2 contract"},[_c('SafetyPrivacyText')],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"inner-page-top-bg faq"},[_c('div',[_c('h1',{staticClass:"h1"},[_vm._v("KİŞİSEL VERİLERİN KORUNMASI VE GİZLİLİK")]),_c('img',{attrs:{"src":require("@/assets/images/arrow-down.png"),"alt":""}})])])
}]

export { render, staticRenderFns }